import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDetailStickyViewRevamp from "./component";
import { createOrder, getValidQuotesInHouseFinance, updateBasicHubspot } from "../checkout-info/actions";
import { updateProfile } from "../../au.configuration/actions";
import { startPreApprovalOnFly } from "../pre-approval-on-fly-modal/actions";
import { setTestDriveVariant, getOrderDetailSuccess } from "../test-drive-v2/actions";
import { getInhouseEligibility, getInhousePreApprovalLoanDetails } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";

const mapStateToProps = ({
    carDetails: {
        content
    },
    user: {
        isLoggedIn,
        secureToken,
        isUserZeroDpVariant,
        email: userEmail
    },
    tradeIn: {
        userTradeInData,
        tradeInToggleSelected
    },
    checkout: {
        order,
        order: { orderId},
        personalDetails
    },
    config: {
        testDriveConfig
    },
    abExperiment: {
        preApprovalOnFlyDesktop
    } = {}
}) => ({
    content,
    isLoggedIn,
    secureToken,
    userTradeInData,
    tradeInToggleSelected,
    order,
    isUserZeroDpVariant,
    personalDetails,
    orderId,
    testDriveConfig,
    preApprovalOnFlyDesktop,
    userEmail
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createOrderConnect: createOrder,
    updateProfileConnect: updateProfile,
    startPreApprovalOnFlyConnect: startPreApprovalOnFly,
    getValidQuotesInHouseFinanceConnect: getValidQuotesInHouseFinance,
    updateBasicHubspotConnect: updateBasicHubspot,
    getOrderDetailSuccessConnect: getOrderDetailSuccess,
    setTestDriveVariantConnect: setTestDriveVariant,
    getInhouseEligibilityConnect: getInhouseEligibility,
    getInhousePreApprovalLoanDetailsConnect: getInhousePreApprovalLoanDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarDetailStickyViewRevamp);
